import React from "react";
import * as Middleware from "@middlewares/index";

const LoyaltyPoints: React.FC = () => {
  return (
    <div className="modal-wrap">
      <button
        className="modal__close"
        onClick={() => {
          Middleware.Ui.Modal.close();
        }}
      />
      <div className="modal modal--content">
        <div className="modal__header">
          <h1 className="modal__title">
            Как заработать больше баллов Loyalty?
          </h1>
        </div>
        <div className="modal__body">
          <div className="modal__rating-star-grid">
            <div>Регистрация на онлайн-выставку</div>
            <div>+10 баллов</div>
            <div>Просмотр эфиров выставки в онлайне с 7 по 28 апреля</div>
            <div>+100 баллов</div>
            <div>Просмотр эфиров в архиве</div>
            <div>+20 баллов</div>
            <div>
              Просмотр стендов экспонентов онлайн-мероприятия (один раз за
              онлайн-мероприятие)
            </div>
            <div>+10 баллов </div>
            <div>
              Скачивание каталогов экспонентов онлайн-мероприятия (за каждый
              каталог один раз за онлайн-мероприятие)
            </div>
            <div>+15 баллов</div>
            <div>
              Внесение брони на сайте Loyalty (доступно для тех, кто осуществлял
              бронирование у{" "}
              <a href="https://profi.travel/loyalty#partners" target="_blank">
                партнёров программы Loyalty
              </a>
              )
            </div>
            <div>от 100 баллов</div>
            <div>Прохождение финального тестирования</div>
            <div>+1 000 баллов</div>
            <div>Прохождение опроса об участии в онлайн-выставке</div>
            <div>+1 000 баллов</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoyaltyPoints;
